/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=Symbol("getSliceableSymbol");function t(t){return"object"==typeof t&&!!t&&o in t}function e(e){return t(e)?e[o]:void 0}export{e as getSliceableContainer,o as getSliceableContainerSymbol};
